const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUbiquiti(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 512,
    r: 512,
    style: {
      fill: "#0559c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.6 385q0-31.49 20.72-58.54t107.68-27V518l-9.91 31.93a212.89 212.89 0 0 1-18.92 43.69 144.75 144.75 0 0 1-26.58 33.49 136.56 136.56 0 0 1-34.46 23.29A175.8 175.8 0 0 1 585 663.93a217.46 217.46 0 0 0 3.61-38.58zM384 324.2h25.69V349H384v-24.8zm25.69 37.69h25.71v24.85h-25.67zM384 393.38h25.7v24.85H384zm-25.67 37.27H384v25.27h-25.64zM307 298.92h25.67v25.28H307zm128.4 326.43q0 32.37 11.94 56.33t26.37 39.91q14.4 16 26.35 23.74l11.94 7.75q-48.19 0-86.27-13.52t-64.44-37.7a163.16 163.16 0 0 1-40.32-57q-14-32.84-14-71V368.11h25.67V505.6h25.7v-24.83H384v55.43h25.69v-93.13h25.71zm94.6 51.89q35.6 1.32 65.34-5.33a163.23 163.23 0 0 0 53.38-22 148.87 148.87 0 0 0 40.78-39.48q17.12-24.15 27.48-57.87v21.34q0 36.37-12.39 67.64a159.64 159.64 0 0 1-36.28 55q-23.87 23.74-58.12 38.37t-77.92 17.29l-15.33-8q-1.79-1.32-29.73-23.29t-38.3-66.3a151.75 151.75 0 0 0 35.38 15.3q20.05 6 45.71 7.33zM358.36 349.47h25.24v24.85h-25.24z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbiquiti);
export default __webpack_public_path__ + "static/media/Ubiquiti.0f6580534414b4960ff470ed4c543bb0.svg";
export { ForwardRef as ReactComponent };